import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDStack,
} from '@facet-wealth/design';
import HoldingsSectionContent
  from 'Views/Page/Content/Templates/AccountProposalReviewTemplate/Content/HoldingsSection/Content';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import Text from 'Components/ComponentLibrary/Atoms/Text';

export const HoldingsSectionForScenarioSelectionModelUpdate = ({
  color = 'primary',
  holdingsCollection,
  holdingsTypeLabel,
  holdingsPercentage,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <FDAccordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <FDAccordionTitle>
        <FDStack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
          {/* FD components don't support the color that I need */}
          <FDStack direction={'row'} alignItems={'center'} spacing={2}>
            <Icon icon={CircleIcon} fill={color} />
            <Text color={color} variant={'h5'} weight={'medium'} text={holdingsTypeLabel} />
          </FDStack>
          <Text color={color} variant={'h5'} weight={'medium'} text={`${holdingsPercentage}%`} />
        </FDStack>
      </FDAccordionTitle>
      <FDAccordionDetails>
        <HoldingsSectionContent
          holdingsCollection={holdingsCollection}
          color={color}
        />
      </FDAccordionDetails>
    </FDAccordion>
  );
};

HoldingsSectionForScenarioSelectionModelUpdate.propTypes = {
  color: PropTypes.string,
  holdingsCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  holdingsTypeLabel: PropTypes.string.isRequired,
  holdingsPercentage: PropTypes.string.isRequired,
};
